/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import styled from "styled-components";

import { useCurrentUser } from "src/app/useCurrentUser";
import { Block } from "src/classes/block";
import { ImageBlock } from "src/classes/block/block-types";
import { BasePlate } from "src/classes/plate/BasePlate/BasePlate";
import { BaseUser } from "src/classes/user";
import { ImageAttributes } from "src/components/DrilledView/SidePanel/Sections/ImageAttributes";
import { LikedBy } from "src/components/Shared/Likes/LikedBy";
import { Username } from "src/components/Shared/User/Username";
dayjs.extend(relativeTime);

//@todo jank
interface BProps {
  block: Block;
  blockOwner: BaseUser;
  likedBy: BaseUser[];
}
export function BlockAttributes({ block, blockOwner, likedBy }: BProps) {
  const currentUser = useCurrentUser();
  return (
    <AttributesTable>
      <tbody>
        <tr>
          <TD isFirstColumn>&lt;by&gt;</TD>
          <TD>
            <Username user={blockOwner} />
          </TD>
        </tr>
        <tr>
          <TD isFirstColumn>&lt;time&gt;</TD>
          <TD>{dayjs(block.snapshot.createdAt).fromNow()}</TD>
        </tr>
        {block instanceof ImageBlock && <ImageAttributes block={block} />}
        {currentUser && (
          <tr>
            <TD isFirstColumn>&lt;likedBy&gt;</TD>
            <TD style={{ padding: 0 }}>
              <LikedBy users={likedBy} />
            </TD>
          </tr>
        )}
      </tbody>
    </AttributesTable>
  );
}

interface PProps {
  plate: BasePlate;
  blockOwner: BaseUser;
  likedBy: BaseUser[];
}
export function PlateAttributes({ plate, blockOwner, likedBy }: PProps) {
  const currentUser = useCurrentUser();
  return (
    <AttributesTable>
      <tbody>
        <tr>
          <TD isFirstColumn>&lt;by&gt;</TD>
          <TD>
            <Username user={blockOwner} />
          </TD>
        </tr>
        <tr>
          <TD isFirstColumn>&lt;time&gt;</TD>
          <TD>{dayjs(plate.snapshot.createdAt).fromNow()}</TD>
        </tr>
        {currentUser && (
          <tr>
            <TD isFirstColumn>&lt;likedBy&gt;</TD>
            <TD style={{ padding: 0 }}>
              <LikedBy users={likedBy} />
            </TD>
          </tr>
        )}
      </tbody>
    </AttributesTable>
  );
}

const AttributesTable = styled.table`
  border-collapse: collapse;
  font-size: 12px;
  user-select: none;
  max-width: 100%;
`;

export const TD = styled.td<{ isFirstColumn?: boolean }>`
  border: ${({ theme }) => `1px solid ${theme.primary}`};
  padding: 10px 14px;
  font-weight: ${({ isFirstColumn }) => (isFirstColumn ? "bold" : "normal")};
  line-height: 12px;
  white-space: nowrap;
  overflow-x: auto;
  height: 42px;
  max-width: 154px;
`;

// const StyledTextArea = styled.textarea`
//   width: 100%;
//   font-size: inherit;
//   font-family: inherit;
//   color: ${({ theme }) => theme.text.default};
//   background-color: inherit;
//   resize: none;
//   border: none;
//   outline: none;
//   ::-webkit-scrollbar {
//     display: none;
//   }
//   ::placeholder {
//     color: ${({ theme }) => theme.text.subtle};
//   }
// `;

// const StyledInput = styled.input`
//   color: ${({ theme }) => theme.text.default};
//   background-color: ${({ theme }) => theme.background};
//   font-family: "IBM Plex Mono";
//   padding: 10px;
//   font-size: 11px;
//   border: ${({ theme }) => `2px solid ${theme.block.border}`};
//   height: 30px;
//   outline: none;
//   margin-right: 24px;
//   &:focus {
//     border-color: ${({ theme }) => theme.primary};
//   }
//   ::placeholder {
//     color: ${({ theme }) => theme.text.subtle};
//     user-select: none;
//   }
// `;
